/**
 * Colour checkbox list — each row shows the colour chip next to the label.
 *
 * Extracted from `app/(main)/products/ProductsClient.tsx` lines 1414–1434.
 */

"use client";

import { Checkbox } from "@/components/ui/checkbox";
import { getColourStyle } from "../product-card-utils";
import { FilterSection } from "./FilterSection";

interface ColourSectionProps {
  colours: string[];
  selected: string[];
  onToggle: (c: string) => void;
  isOpen: boolean;
  onToggleSection: (title: string) => void;
}

export function ColourSection({
  colours,
  selected,
  onToggle,
  isOpen,
  onToggleSection,
}: ColourSectionProps) {
  return (
    <FilterSection
      title="Colour"
      count={selected.length}
      isOpen={isOpen}
      onToggle={onToggleSection}
    >
      <div className="flex flex-col gap-2">
        {colours.map((c) => (
          <label
            key={c}
            className="flex cursor-pointer items-center gap-3 py-1 text-sm text-foreground"
          >
            <Checkbox
              checked={selected.includes(c)}
              onCheckedChange={() => onToggle(c)}
            />
            <span
              className="size-4 shrink-0 rounded-full border border-border shadow-sm"
              style={getColourStyle(c)}
              aria-hidden="true"
            />
            <span>{c}</span>
          </label>
        ))}
      </div>
    </FilterSection>
  );
}
